registerComponent("product-blocks/product-differentials", function (component) {

});
